// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4c8811fcde37352092b9","655":"39eafca3596f0a5752c6"}[chunkId] + ".js";
};